import { Flags } from "../interfaces/Flags";

const flags: Flags[] = [
    { label: 'Bretas', value: 'Bretas' },
    { label: 'Gbarbosa', value: 'Gbarbosa' },
    { label: 'Mercantil', value: 'Mercantil' },
    { label: 'Perini', value: 'Perini' },
    { label: 'Prezunic', value: 'Prezunic' },
];

export default flags